var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout-wrapper"},[_c('el-aside',{staticClass:"layout-aside",attrs:{"width":"200px"}},[_c('app-menu')],1),_c('el-container',{staticClass:"layout-right"},[_c('el-header',{staticClass:"layout-header",attrs:{"height":"60px"}},[_c('app-header')],1),_c('el-main',{staticClass:"layout-main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }